/** @jsx jsx */
import { Link, jsx } from 'theme-ui'
import PropTypes from 'prop-types'
import { Link as GatsbyLink } from 'gatsby'
import React from 'react'
import { string } from 'prop-types'
import parseLinkTokens from '../../utils/parseLinkTokens'
import DistribionLink from '../common/DistribionLink'

const CustomLink = ({ node, children }) => {
  const [text] = children
  // TODO: if we see the error about invalid prop type text supplied to custom link we can implmement this as the solution
  // const textOnly = Array.isArray(text) ? text[1] : text
  const { uri } = node
  return (
    <React.Fragment>
      {uri.includes('/app') || uri.includes('/article') ? (
        <DefaultLink uri={uri} text={Array.isArray(text) ? text[1] : text} />
      ) : uri.toLowerCase() === parseLinkTokens?.DISTRIBION ? (
        <div>
          <DistribionLink text={text} />
        </div>
      ) : uri.toLowerCase() === parseLinkTokens?.EASYSITE ? (
        <Link
          target="_blank"
          href={`${process.env.GATSBY_COMMLINK_URL}/Login/auto/autoLogin.aspx?SendMeHere=${process.env.GATSBY_COMMLINK_URL}/applications/SingleSignOn/EasySite/SSO/Launch`}
          sx={{ variant: 'links.navigation' }}
        >
          <span>{text}</span>
        </Link>
      ) : uri.toLowerCase().includes(parseLinkTokens?.COMMLINK) ? (
        <Link
          target="_blank"
          href={`${process.env.GATSBY_COMMLINK_URL}/applications/CommLink/RegisterRedirect.aspx`}
          sx={{ variant: 'links.navigation' }}
        >
          <span>{text}</span>
        </Link>
      ) : uri.toLowerCase().includes('home.commonwealth.com') ? (
        <Link
          variant="special"
          href={`https://home.commonwealth.com/Login/auto/autoLogin.aspx?SendMeHere=${uri}`}
          sx={{ fontSize: 1, cursor: 'pointer', fontWeight: 'normal' }}
          target="_blank"
          rel="noopener noreferrer"
        >
          {text}
        </Link>
      ) : uri.toLowerCase().includes(process.env.GATSBY_COMMLINK_URL) ? (
        <Link
          variant="special"
          href={`${process.env.GATSBY_COMMLINK_URL}/Login/auto/autoLogin.aspx?SendMeHere=${uri}`}
          sx={{ fontSize: 1, cursor: 'pointer', fontWeight: 'normal' }}
          target="_blank"
          rel="noopener noreferrer"
        >
          {text}
        </Link>
      ) : (
        <Link
          variant="special"
          href={uri}
          sx={{ fontSize: 1, cursor: 'pointer', fontWeight: 'normal' }}
          target="_blank"
          rel="noopener noreferrer"
        >
          {text}
        </Link>
      )}
    </React.Fragment>
  )
}

CustomLink.propTypes = {
  node: PropTypes.object.isRequired,
  children: PropTypes.array.isRequired,
}

export default CustomLink

export const DefaultLink = ({ text, uri, dataAutomationId }) => {
  return (
    <GatsbyLink
      to={uri}
      data-automation-id={dataAutomationId}
      sx={{
        fontSize: 1,
        cursor: 'pointer',
        fontFamily: 'heading',
        fontWeight: 'normal',
        color: 'primary',
        lineHeight: 'heading',
        textDecoration: 'underline',
        textDecorationColor: 'lightBlue',
      }}
    >
      {text}
    </GatsbyLink>
  )
}

DefaultLink.propTypes = {
  text: string.isRequired,
  uri: string,
  dataAutomationId: string,
}
